import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import { Link as LinkRouter } from 'react-router-dom';
import { APPLICATION_STATUS } from '../../../../../constants/event-application-status';
import { APP_ROUTES } from '../../../../../constants/app-routes';
import { createRefundRequest } from '../../../../../core/vendor-events/action';
import { useStorageImage } from '../../../../../hooks/useStorageImage';

export default function RowRefund({ row }) {
  const { user, asset } = row;
  const dispatch = useDispatch();
  const { loading } = useSelector((store) => store.vendorEvents);
  const [redirect, setRedirect] = useState(false);

  const onClickRefund = (refundId, status) => {
    dispatch(createRefundRequest(refundId, user?.id, status));
    setRedirect(true);
  };

  useEffect(() => {
    if (loading === false && redirect === true) window.location.reload();
  }, [loading, redirect]);

  const photo = useStorageImage(asset?.s3_object_key);

  return (
    <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
      <TableCell align="left">{row?.id}</TableCell>
      <TableCell align="left">
        <LinkRouter to={APP_ROUTES.VENDOR_PUBLIC_PROFILE.replace(':vendorId', user.id)}>
          {user?.name} {user?.last_name}
        </LinkRouter>
      </TableCell>
      <TableCell align="left">{`USD $${row?.amount}`}</TableCell>
      <TableCell align="left">{row?.description}</TableCell>
      <TableCell align="left">{row?.status}</TableCell>
      <TableCell align="left">
        {photo ? (
          <LinkRouter to={photo} target="_blank">
            {asset?.id}
          </LinkRouter>
        ) : (
          'No file'
        )}
      </TableCell>
      <TableCell align="left">
        {row.status === APPLICATION_STATUS.PENDING && (
          <>
            <Button
              style={{ borderRadius: 20 }}
              variant="contained"
              color="primary"
              onClick={() => onClickRefund(row?.id, APPLICATION_STATUS.APPROVED)}>
              Accept refund
            </Button>
            <Button
              style={{ borderRadius: 20, marginLeft: '2px' }}
              variant="outlined"
              color="primary"
              onClick={() => onClickRefund(row?.id, APPLICATION_STATUS.DENIED)}>
              Decline refund
            </Button>
          </>
        )}
      </TableCell>
    </TableRow>
  );
}

RowRefund.propTypes = {
  row: PropTypes.instanceOf(Object).isRequired,
};
